export enum SizeType {
  SMALL,
  BIG,
}
